export default __webpack_public_path__ + "static/media/thumbnail.e0598b8b.png";